export const PAGE_PATH = '/education';
